<!--Mobile Header-->
<fgb-page-header [pageTitle]="'rewards.page.title'" [showBanner]="true" [backButtonLink]="'/'"></fgb-page-header>
<!--Sub Nav-->
<div class="container">
  <fgb-mixed-loyalty-nav></fgb-mixed-loyalty-nav>
</div>

<div class="container mt-3">
  <fgbcl-marketplace-list
    [isList]="true"
    [marketplaceItemView]="true"
    [marketplaceItemTypes]="[0, 1, 2]"
    [defaultSort]="2"
  ></fgbcl-marketplace-list>
</div>
